import { RegisterOptions } from 'react-hook-form';

import {
  useCountrySubregionsLocalizationQuery,
  useSubregions,
} from '~src/country-subregions/country-subregions';
import { SearchableSelect } from '~src/ui/searchable-select';
import { SelectInputV2 } from '~src/ui/select-input-v2';

import { StaticInputProps } from '../config/static-props';

interface SubregionProps extends Partial<StaticInputProps> {
  validationRules: RegisterOptions;
  label: string;
  fieldType?: string;
}

export const SubregionInput: React.FC<SubregionProps> = ({
  label,
  validationRules,
  fieldType,
  ...props
}) => {
  useCountrySubregionsLocalizationQuery();

  const subregions = useSubregions();
  const isSearchable = fieldType === 'searchable';

  return isSearchable ? (
    <SearchableSelect
      {...props}
      name="subregion"
      label={label}
      options={subregions}
      validationRules={validationRules}
    />
  ) : (
    <SelectInputV2
      {...props}
      name="subregion"
      label={label}
      validationRules={validationRules}
      options={subregions}
    />
  );
};
